import { flow } from 'lodash'
import { getRootState } from 'store/shared'

export const getOptionsIncomeAndExpenseReportRootState = flow(
  getRootState,
  (x) => x.modules.advisory.modules.reports.optionsAndIncomeExpense
)
